import React, { useRef } from "react";
import BsyIconBtn from "../components/BsyIconBtn";
import BsySlidePane from "../components/BsySlidePane";
import piexif from "piexifjs";
import BsyMaskLayer from "../components/BsyMaskLayer";
import BsySLoading from "../components/BsySLoading";

export function doGraffiti(args) {

  const refIframeContainer = React.createRef();

  let slideHandle = null;
  let exifObj = null;
  let singleInstance = null;

  async function readNetworkImage(imageUrl) {
    try {
      // 获取图片数据
      const response = await fetch(imageUrl);
      const blob = await response.blob();

      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = function (e) {
          try {
            exifObj = piexif.load(e.target.result);
            console.log('EXIF数据加载成功:', exifObj);
            resolve(exifObj);
          } catch (error) {
            console.warn('EXIF数据解析失败，将使用空对象:', error);
            exifObj = {};
            resolve({});
          }
        };

        reader.onerror = function (error) {
          console.error('读取错误:', error);
          exifObj = {};
          reject(error);
        };
        // 读取为DataURL
        reader.readAsDataURL(blob);
      });

    } catch (error) {
      console.error('获取网络图片失败:', error);
      exifObj = {};
      return {};
    }
  }

  // 获取远程图片中的exif数据，用于涂鸦时回写
  readNetworkImage(args.file.originalUrl).catch(err => {
    console.error('加载EXIF数据失败:', err);
  });

  let layerRefLoading = null;

  // 获取涂鸦数据，并回写到图片组件中
  const getData = async (type) => {

    if (refIframeContainer.current) {

      singleInstance = new Date().getTime();
      const ext = args.file.name.split(".").pop();

      refIframeContainer.current.contentWindow.postMessage({
        type: 'getData',
        data: {
          type: type,
          ext: ext,
          singleInstance: singleInstance
        }
      }, window.location.origin);

      BsyMaskLayer({
        customCls: "sloading",
        onContentCreate: (ref) => {
          layerRefLoading = ref;
          return (
            <div>
              <BsySLoading />
            </div>
          );
        },
      });
    }


  }


  const saveData = (data) => {
    const { dataURL, type, ext } = data;
    let finalDataURL = dataURL;

    // 只有当图片格式是JPEG且有EXIF数据时才尝试插入EXIF
    if (['jpeg', 'jpe', 'jpg'].includes(ext.toLocaleLowerCase()) && exifObj && Object.keys(exifObj).length > 0) {
      try {

        if (exifObj && exifObj['0th']) {
          exifObj['0th'][piexif.ImageIFD.Orientation] = 1;
        }

        const exifBytes = piexif.dump(exifObj);
        finalDataURL = piexif.insert(exifBytes, dataURL);
      } catch (exifError) {
        console.warn('插入EXIF数据失败，将使用原始图片:', exifError);
        finalDataURL = dataURL;
      }
    }

    args.onSave(finalDataURL, type, () => {
      if (layerRefLoading && layerRefLoading.close) {
        layerRefLoading.close();
        layerRefLoading = null;
      }
      if (slideHandle && slideHandle.close) {
        slideHandle.close();
      }
    });
  }

  // 父窗口接收iframe消息
  window.addEventListener('message', (event) => {
    // 验证消息来源
    if (event.origin !== window.location.origin) return;
    if (['save', 'cover'].includes(event.data.type)) {
      console.log('singleInstance:', singleInstance, event.data.singleInstance);
      if (singleInstance === event.data.singleInstance) {
        singleInstance = null;
        saveData(event.data);
      }
    }
  });


  BsySlidePane({
    title: React.language("Graffiti"),
    theme: "bsy-graffiti",
    hasHeader: true,
    onHeaderMenu: () => {
      return <div className="slide-dash-menu"
        style={{
          top: 9
        }}
      >

        <BsyIconBtn
          style={{
            marginRight: 10
          }}
          text={React.language("save.as")}
          click={(event) => {
            getData("save");
          }}
          type={"blue"}
          mode={window.mode}
        />
        <BsyIconBtn
          text={React.language("cover")}
          click={(event) => {
            getData("cover");
          }}
          type={"border-blue"}
          mode={window.mode}
        />
      </div>
    },
    onContentCreate: (hdREf) => {
      slideHandle = hdREf;
      return (
        <iframe
          className="file-box-preview"
          ref={refIframeContainer}
          src={'/template/formreport/static/js/custom-tui-image-edit/index.html?src=' + encodeURIComponent(args.file.originalUrl)}
          title={React.language("save.as")}
          frameborder="0"
          style={{ width: "100%", height: "100%" }}
        />
      )
    },
  })

}